import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetAnalyticEntitiesQuery {
    constructor(
        private readonly dispatcher: QueryDispatcher
    ) {}
    
    async run(company_id:number): Promise<any> {
        let res = undefined
        try {
            let args = {company_id: company_id}
            res = await this.dispatcher.dispatch('get.bank.analytic.entities', args)
        } catch (error) {
            res = []
            console.log('Error while getting current company analytic entities:', error)
        }
        return res
    }
}